import { createReducer } from "@reduxjs/toolkit";
import {
    AddPersons,
    getNearMissListSuccess,
    loadingList,
    saveNearMissListSuccess,
    SetPersons,
    setTriggerSignClearCount,
} from "./nearMissReducer";

export interface INearMissState {
    NearMissList: Array<any>;
    dataCount: number;
    persons: any[];
    isLoading: boolean;
    triggerSignClearCount: number;
}

const initialState: INearMissState = {
    NearMissList: [],
    persons: [],
    dataCount: 0,
    isLoading: false,
    triggerSignClearCount: 0,
};

export const nearMissReducer = createReducer(initialState, (builder) => {
    builder

        .addCase(setTriggerSignClearCount, (state, action) => {
            state = {
                ...state,
                triggerSignClearCount: action.payload,
            };
            return state;
        })
        .addCase(getNearMissListSuccess, (state, action) => {
            state = {
                ...state,
                NearMissList: action.payload?.data,
                dataCount: action.payload?.dataCount,
            };
            return state;
        })
        .addCase(SetPersons, (state, action) => {
            let data = (action.payload ?? []).map((item, index) => {
                let cpy = { ...item };
                cpy["key"] = index + 1;
                return cpy;
            });
            state = {
                ...state,
                persons: data,
            };
            return state;
        })
        .addCase(saveNearMissListSuccess, (state, action) => {
            state = {
                ...state,
                NearMissList: action.payload,
            };
            return state;
        })
        .addCase(AddPersons, (state, action) => {
            let update = {
                ...action.payload,
                key: (state.persons ?? [])?.length + 1,
            };
            // console.log(update);
            state = {
                ...state,
                persons: (state?.persons ?? []).concat(update),
            };
            return state;
        })

        .addCase(loadingList, (state, action) => {
            state = {
                ...state,
                isLoading: action.payload,
            };
            return state;
        });
});
